import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  defaultHeaderConfig,
  headerConfig,
  headerConfigurableType,
} from '../../frontend_common/HeaderConfig';
import { detectIsPadOrMobileByScreenWidth } from '../../utils/ScreenUtils';
import i18n from '../../utils/I18n';
import PointToCashSection from './PointToCashSection';
import './PointToCashBanner.scss';

const PointToCashBanner = ({
  language,
  isLogin,
  firstName,
}) => {
  const location = useLocation();

  const isMobile = detectIsPadOrMobileByScreenWidth();

  const [navBarConfig, setNavBarConfig] = useState({});

  useEffect(() => {
    let config = defaultHeaderConfig;
    headerConfig.forEach((item) => {
      if (location.pathname.indexOf(item.pathname) !== -1) {
        config = item;
      }
    });
    setNavBarConfig(config);
  }, [])


  if (!isLogin || !isMobile) {
    return null;
  };

  if (
    navBarConfig.type === headerConfigurableType.logo
    && navBarConfig.showPointToCashBanner
  ) {
    return (
      <div
        className="point-to-cash-banner-container"
      >
        <div className='point-to-cash-banner-left-section'>
          <span className='point-to-cash-banner-hello headline'>
            {i18n.t("home_hello")}!
          </span>
          <span className='point-to-cash-banner-first-name subheading'>
            {firstName}
          </span>
        </div>
        <div className='point-to-cash-banner-section'>
          <PointToCashSection inBanner />
        </div>
      </div>
    )
  }

  return null;
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  firstName: state.users.userInfo?.firstName,
});

export default connect(mapStateToProps)(PointToCashBanner);
